import { useContext } from 'react'
import MunicipalityContext from '../contexts/MunicipalityContext'

const useMunicipality = () => useContext(MunicipalityContext)

export default useMunicipality